import React, { useState, useRef, useEffect } from "react";
import apiRoutes from "../../../api/apiRoutes";
import { appFetchJson, apiFetchJson } from "../../../utils/http";

function useOutside(ref, onClose) {
  useEffect(() => {
    const handle = (e) => {
      if (ref.current && !ref.current.contains(e.target)) onClose();
    };
    document.addEventListener("mousedown", handle);
    return () => document.removeEventListener("mousedown", handle);
  }, [ref, onClose]);
}

function useDebounced(value, delay = 300) {
  const [v, setV] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setV(value), delay);
    return () => clearTimeout(t);
  }, [value, delay]);
  return v;
}

export default function FiltroEstados({
  initialFilters = { descripcion: "", tipoId: "" },
  onSubmit = () => {},
  onClose = () => {},
}) {
  const [descripcion, setDescripcion] = useState(
    initialFilters.descripcion || "",
  );
  const [tipoEstado, setTipoEstado] = useState(initialFilters.tipoId || "");
  const debDescripcion = useDebounced(descripcion, 300);
  const [descItems, setDescItems] = useState([]);
  const [descOpen, setDescOpen] = useState(false);
  const [descLoading, setDescLoading] = useState(false);
  const descBoxRef = useRef(null);

  const [tiposEstado, setTiposEstado] = useState([]);
  const [loadingTipos, setLoadingTipos] = useState(false);

  const panelRef = useRef(null);
  useOutside(panelRef, onClose);

  useEffect(() => {
    const loadTiposEstado = async () => {
      setLoadingTipos(true);
      try {
        const url = apiRoutes.estadoTipo.listUrl({
          page: 0,
          size: 1000,
        });
        const data = await appFetchJson(url);
        setTiposEstado(data?.items ?? []);
      } catch (err) {
        console.error("Error cargando tipos de estado:", err);
      } finally {
        setLoadingTipos(false);
      }
    };
    loadTiposEstado();
  }, []);

  useEffect(() => {
    const onDoc = (e) => {
      if (descBoxRef.current && !descBoxRef.current.contains(e.target)) {
        setDescOpen(false);
      }
    };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, []);

  useEffect(() => {
    if (!descOpen) return;

    const loadEstados = async () => {
      setDescLoading(true);
      try {
        const url = apiRoutes.estado.listUrl({
          page: 0,
          size: 100,
          q: debDescripcion,
        });
        const data = await apiFetchJson(url);
        setDescItems(data?.items ?? []);
      } catch (e) {
        console.error("Autocomplete estados:", e);
      } finally {
        setDescLoading(false);
      }
    };

    loadEstados();
  }, [debDescripcion, descOpen]);

  const submit = (e) => {
    e.preventDefault();
    onSubmit({
      descripcion,
      tipoId: tipoEstado || null,
    });
    onClose();
  };

  return (
    <div className="drawer-backdrop">
      <div
        ref={panelRef}
        className="drawer-panel overflow-auto"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="drawer-header">
          <h2 className="text-title">Filtros de Estado</h2>
          <button onClick={onClose} className="btn-cancel" title="Cerrar">
            &times;
          </button>
        </div>

        <form onSubmit={submit} className="drawer-body space-y-3">
          <div ref={descBoxRef} className="relative">
            <label className="form-label-fil">Descripción:</label>
            <input
              type="text"
              className="input"
              placeholder="Buscar estado..."
              value={descripcion}
              onChange={(e) => {
                setDescripcion(e.target.value);
                setDescOpen(true);
              }}
              onFocus={() => setDescOpen(true)}
            />

            {descOpen && (
              <div className="absolute z-50 mt-1 w-full border rounded bg-white shadow-xl max-h-56 overflow-auto">
                {descItems.map((e) => (
                  <button
                    key={e.id}
                    type="button"
                    className="w-full text-left px-3 py-2 hover:bg-gray-50"
                    onClick={() => {
                      setDescripcion(e.nombre);
                      setDescOpen(false);
                    }}
                  >
                    {e.nombre}
                  </button>
                ))}

                {descLoading && (
                  <div className="px-3 py-2 text-sm text-gray-500">
                    Cargando…
                  </div>
                )}

                {!descLoading && descItems.length === 0 && (
                  <div className="px-3 py-2 text-sm text-gray-500">
                    Sin resultados
                  </div>
                )}
              </div>
            )}
          </div>

          <div>
            <label className="form-label-fil">Estado Tipo*:</label>
            <select
              className="input"
              value={tipoEstado}
              onChange={(e) => setTipoEstado(e.target.value)}
            >
              <option value="">--- Seleccione ---</option>
              {tiposEstado.map((t) => (
                <option key={t.id} value={t.id}>
                  {t.nombre}
                </option>
              ))}
            </select>
          </div>

          <div className="text-right mt-4">
            <button type="submit" className="btn">
              Consultar
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
